/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import angular from '@xlts.dev/angular';
import ngCookies from '@xlts.dev/angular-cookies';
import ngResource from '@xlts.dev/angular-resource';
import ngSanitize from '@xlts.dev/angular-sanitize';
import ngTranslate from 'angular-translate/dist/angular-translate.js';
import ngTranslateLoaderStaticFiles from 'angular-translate/dist/angular-translate-loader-static-files/angular-translate-loader-static-files.js';
import uiRouter from '@uirouter/angularjs/release/angular-ui-router.js';
import uiBootstrap from 'angular-ui-bootstrap';
import coreServiceProvider from './app.core.service.js';

/**
 * This is the shared dependencies module. It will be referenced by most application modules.
 * Only declare the module's dependencies in this file.
 * @namespace Application Core Module
 */
angular.module('core', [
  // Angular modules.
  ngCookies,
  ngResource,
  ngSanitize,
  // Component Modules.
  // 'example-component',
  // 3rd-party modules.
  'pascalprecht.translate',
  'ui.router',
  'ui.bootstrap'
])
// Register service.
.provider('coreService', coreServiceProvider);

export default 'core';


// WEBPACK FOOTER //
// ./src/app.core.module.js